/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
import { FileStatus } from '.zenstack/models';
import { FileStatusSchema } from '../enums/FileStatus.schema';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    key: z.string(),
    name: z.string(),
    type: z.string(),
    url: z.string(),
    size: z.number(),
    isPublic: z.boolean().default(false),
    status: FileStatusSchema,
    orderIndex: z.number().default(0),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    key: z.string(),
    name: z.string(),
    type: z.string(),
    url: z.string(),
    size: z.number(),
    isPublic: z.boolean(),
    status: FileStatusSchema,
    orderIndex: z.number(),
}
).strict();
const relationSchema = z.object({
    userFile: z.record(z.string(), z.unknown()),
    availableTo: z.array(z.unknown()).optional(),
    avatar: z.record(z.string(), z.unknown()).optional(),
    comment: z.record(z.string(), z.unknown()).optional(),
    reply: z.record(z.string(), z.unknown()).optional(),
    listing: z.record(z.string(), z.unknown()).optional(),
}
);
const fkSchema = z.object({
    userFileId: z.string(),
    avatarId: z.string().nullish(),
    commentId: z.string().nullish(),
    replyId: z.string().nullish(),
    listingId: z.string().nullish(),
}
);

/**
* Schema refinement function for applying `@@validate` rules.
*/
export function refineFile<T, D extends z.ZodTypeDef>(schema: z.ZodType<T, D, T>) {
    return schema.refine((value: any) => ((((((((value?.avatarId !== null && value?.avatarId !== undefined) && (value?.commentId === null || value?.commentId === undefined)) && (value?.replyId === null || value?.replyId === undefined)) && (value?.listingId === null || value?.listingId === undefined)) || ((((value?.avatarId === null || value?.avatarId === undefined) && (value?.commentId === null || value?.commentId === undefined)) && (value?.replyId === null || value?.replyId === undefined)) && (value?.listingId === null || value?.listingId === undefined))) || ((((value?.avatarId === null || value?.avatarId === undefined) && (value?.commentId !== null && value?.commentId !== undefined)) && (value?.replyId === null || value?.replyId === undefined)) && (value?.listingId === null || value?.listingId === undefined))) || ((((value?.avatarId === null || value?.avatarId === undefined) && (value?.commentId === null || value?.commentId === undefined)) && (value?.replyId !== null && value?.replyId !== undefined)) && (value?.listingId === null || value?.listingId === undefined))) || ((((value?.avatarId === null || value?.avatarId === undefined) && (value?.commentId === null || value?.commentId === undefined)) && (value?.replyId === null || value?.replyId === undefined)) && (value?.listingId !== null && value?.listingId !== undefined))), { message: "File must belong to exactly one entity type", });
}


/**
 * `File` schema excluding foreign keys and relations.
 */
export const FileScalarSchema = baseSchema;


/**
 * `File` schema prior to calling `.refine()` for extensibility.
 */
export const FileWithoutRefineSchema = FileScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * `File` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const FileSchema = refineFile(FileWithoutRefineSchema);


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const FilePrismaCreateSchema = refineFile(baseSchemaWithoutDefaults.partial().passthrough());


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const FilePrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    key: z.string(),
    name: z.string(),
    type: z.string(),
    url: z.string(),
    size: z.union([z.number(), z.record(z.string(), z.unknown())]),
    isPublic: z.boolean(),
    status: FileStatusSchema,
    orderIndex: z.union([z.number(), z.record(z.string(), z.unknown())])
}).partial().passthrough();


/**
 * `File` schema for create operations excluding foreign keys and relations.
 */
export const FileCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true, isPublic: true, status: true, orderIndex: true
});


/**
 * `File` schema for create operations prior to calling `.refine()` for extensibility.
 */
export const FileCreateWithoutRefineSchema = FileCreateScalarSchema.merge(fkSchema);


/**
 * `File` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const FileCreateSchema = refineFile(FileCreateWithoutRefineSchema);


/**
 * `File` schema for update operations excluding foreign keys and relations.
 */
export const FileUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `File` schema for update operations prior to calling `.refine()` for extensibility.
 */
export const FileUpdateWithoutRefineSchema = FileUpdateScalarSchema.merge(fkSchema.partial());


/**
 * `File` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const FileUpdateSchema = refineFile(FileUpdateWithoutRefineSchema);

